export default __webpack_public_path__ + "static/FiraCode-SemiBold-0853cec6dada6500c6d5b6da984f158b.ttf";